import { useEffect, useRef } from 'react';
import PerfectScrollbar from 'perfect-scrollbar';

const usePerfectScrollbar = (
    getContainer: () => HTMLDivElement | null,
    options?: PerfectScrollbar.Options
) => {
    // 滚动条实例
    const scrollbarInstance = useRef<{
        scrollbar: PerfectScrollbar;
        container: HTMLDivElement;
    } | null>(null);

    /**
     * 初始化滚动条
     */
    const initScrollbar = () => {
        if (!scrollbarInstance.current) {
            const container = getContainer();
            if (container) {
                scrollbarInstance.current = {
                    scrollbar: new PerfectScrollbar(container, options),
                    container
                };
            }
        }
    };

    /**
     * 更新滚动条
     */
    const updateScrollbar = () => {
        if (scrollbarInstance.current) {
            const { scrollbar } = scrollbarInstance.current;
            scrollbar.update();
        }
    };

    /**
     * 销毁滚动条
     */
    const destroyScrollbar = () => {
        if (scrollbarInstance.current) {
            const { scrollbar } = scrollbarInstance.current;
            scrollbar.destroy();
            scrollbarInstance.current = null;
        }
    };

    /**
     * 更新滚动条
     * 如果滚动条不存在，则初始化滚动条
     * 如果滚动容器发生变化，则销毁滚动条并重新初始化滚动条
     */
    const initOrUpdateScrollbar = () => {
        if (!scrollbarInstance.current) {
            initScrollbar();
        } else {
            const { container } = scrollbarInstance.current;
            const newContainer = getContainer();
            if (newContainer === container) {
                updateScrollbar();
            } else {
                destroyScrollbar();
                initScrollbar();
            }
        }
    };

    /**
     * 组件卸载时销毁滚动条
     */
    useEffect(() => {
        return () => {
            destroyScrollbar();
        };
    }, []);

    return { initOrUpdateScrollbar };
};

export default usePerfectScrollbar;
